import { format, subDays } from "date-fns";
import stylesList from "./styles.js";
import imagesList from "./images.js";

const pdfReportFormatter = {
    //
    //  This is what gets passed to pdfmake to create the report
    //  ie the DocumentDefinition
    //
    create(feedbacks, options, cb) {
        const _this = this;
        const _options = options;

        var definition = {
            pageSize: "LETTER",
            //Gets filled in
            content: [],
            //
            header: function(currentPage, pageCount) {
                //report page headers
                if (currentPage != 1) {
                    return {
                        table: _this.buildReportHeader(_options, currentPage, pageCount),
                        layout: "noBorders",
                        style: "reportHeader"
                    };
                }

                return false;
            },

            //
            footer: function(currentPage, pageCount) {
                //report page footers
                if (currentPage != 1) {
                    return {
                        table: _this.buildReportFooter(_options, currentPage, pageCount),
                        layout: "noBorders",
                        style: "reportFooterTable",
                        alignment: "center"
                    };
                }
                //dont print on first page
                return false;
            },

            //Report Styles
            styles: stylesList,
            //
            images: imagesList
        };

        //from options we should set all the header information needed
        definition.content.push(this.buildReportCoverPage(options));

        //For each item in our feedbacks format a table to display
        feedbacks.forEach(item => {
            definition.content.push(this.buildFeedbackTable(item));
        });

        //callback with definition
        return definition;
    },

    //
    //
    //
    buildReportCoverPage(options) {
        const reportRange = options.reportRange;
        const date_now = new Date()
        const date_before = new Date(
            date_now.getFullYear(), 
            date_now.getMonth(), 
            date_now.getDate()-reportRange)
        const endDate = date_now.toLocaleDateString('en-US');
        const startDate = date_before.toLocaleDateString('en-US');

        const locationString =
            options.storeName ||
            options.regionName ||
            options.organizationName ||
            "All Organizations";

        const reportParamString = options.reportParamString;

        return {
            style: "reportCoverPageTable",
            table: {
                widths: ["*"],
                body: [
                    [
                        [{
                                image: "budtenderLogoBig",
                                width: 250,
                                alignment: "center",
                                style: "budtenderLogoBig"
                            },
                            {
                                text: "BudTender",
                                alignment: "center",
                                style: "budtenderLogoText"
                            },
                            {
                                text: "powered by springbig",
                                alignment: "center",
                                style: "springbigText"
                            },
                            {
                                text: "Cannabis Customer Experience Leader",
                                alignment: "center",
                                style: "budtenderLogoSubText"
                            }
                        ]
                    ],
                    [{
                        text: "Important Feedback Report",
                        alignment: "center",
                        style: "coverReportTitle"
                    }],
                    [{
                        text: `${reportParamString}`,
                        alignment: "center",
                        style: "coverReportParams"
                    }],
                    [{
                        text: `${startDate} - ${endDate}`,
                        alignment: "center",
                        style: "coverReportDate"
                    }],

                    [{
                        text: `${locationString} `,
                        alignment: "center",
                        style: "coverStoreName"
                    }]
                ]
            },
            layout: "noBorders",
            pageBreak: "after"
        };
    },

    //
    //
    //
    //
    //
    buildFeedbackTable(item) {
        const customerName = item.customer.name || "No name given";
        const customerPhone = item.customer.mobile
            .replace(/[^0-9]/g, "")
            .replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "+$1($2)$3-$4");

        const createdDate = new Date(item.created_at).toDateString().slice(4);

        //// TODO: ADD ICONS?
        const tags = item.user_tags
            .map(tag => {
                switch (tag.tag_type) {
                    case "open":
                        return "Open";
                        break;
                    case "resolved":
                        return "Resolved";
                        break;
                    case "flagged":
                        return "Flagged ";
                        break;
                }
            })
            .join(", ");

        const table = {
            style: "feedbackHeaderTable",
            table: {
                headerRows: 1,
                widths: ["*", 100, 100],
                keepWithHeaderRows: 1,
                body: [
                    [{
                            text: [
                                { text: customerPhone, fontSize: 12 },
                                " | ",
                                { text: customerName, fontSize: 12 }
                            ]
                        },
                        {
                            text: tags,
                            fontSize: 10,
                            alignment: "right"
                        },
                        {
                            text: createdDate,
                            alignment: "right"
                        }
                    ],
                    [{
                        colSpan: 3,
                        alignment: "left",
                        table: this.buildFeedbackResultTable(item),
                        layout: "noBorders"
                    }]
                ]
            },
            layout: "headerLineOnly"
        };

        return table;
    },

    //
    //
    //
    buildFeedbackResultTable(item) {
        const table = {
            widths: [90, "*"],
            body: [
                [{
                        table: this.buildScoresResultTable(item),
                        layout: "noBorders",
                        alignment: "center",
                        style: "resultsTable"
                    },
                    {
                        table: this.buildCommentsResultTable(item),
                        layout: "noBorders",
                        alignment: "center",
                        style: "commentsTable"
                    }
                ]
            ]
        };

        return table;
    },

    //
    //
    //
    buildScoresResultTable(item) {
        const storeName = item.store.name;
        const npsScore = item.nps_score || "n/a";
        const crsScore = item.crs_score || "n/a";
        const productScore = item.product_score || "n/a";

        const table = {
            widths: [30, 30, 30],
            body: [
                [{ text: storeName, alignment: "center", colSpan: 3 }, "", ""],
                [{
                        text: npsScore,
                        alignment: "center",
                        style: {
                            fontSize: 15,
                            bold: true,
                            fillColor: this.buildStyleColor(npsScore)
                        }
                    },
                    {
                        text: crsScore,
                        alignment: "center",
                        style: {
                            fontSize: 15,
                            bold: true,
                            fillColor: this.buildStyleColor(crsScore)
                        }
                    },
                    {
                        text: productScore,
                        alignment: "center",
                        style: {
                            fontSize: 15,
                            bold: true,
                            fillColor: this.buildStyleColor(productScore)
                        }
                    }
                ],
                [
                    { text: "Nps", alignment: "center", style: "small" },
                    { text: "Crs", alignment: "center", style: "small" },
                    { text: "Product", alignment: "center", style: "small" }
                ]
            ]
        };

        return table;
    },

    buildStyleColor(score) {
        if (score > 4) return "#45f0b0";
        if (score == 4) return "#f0d845";
        if (score < 4) return "#f05345";
    },

    //
    //
    //
    buildCommentsResultTable(item) {
        const npsComment = this.buildCommentObject(item.nps_comment);
        const crsComment = this.buildCommentObject(item.crs_comment);
        const productComment = this.buildCommentObject(item.product_comment);

        const table = {
            widths: [110, "auto"],
            body: [
                [{
                        text: "Staff Comments",
                        alignment: "center",
                        style: "commentLabel"
                    },
                    crsComment
                ],
                [{
                        text: "Product Comments",
                        alignment: "center",
                        style: "commentLabel"
                    },
                    productComment
                ],
                [{
                        text: "Other Comments",
                        alignment: "center",
                        style: "commentLabel"
                    },
                    npsComment
                ]
            ]
        };

        return table;
    },

    buildCommentObject(result = false) {
        const noAnswer = {
            text: "No text provided",
            alignment: "left",
            italics: true,
            color: "gray",
            style: "commentNA"
        };

        if (!result) return noAnswer;
        if (!result.length == 1) return noAnswer;
        if (!result) return noAnswer;

        return {
            text: result,
            alignment: "left",
            style: "comment"
        };
    },

    //
    //
    //
    buildReportHeaderFirstPage(_options, currentPage, pageCount) {
        const table = {
            widths: ["*", "*", "*"],
            body: [
                [
                    { text: "left", alignment: "left" },
                    { text: "center", alignment: "center" },
                    { text: "right", alignment: "right" }
                ]
            ]
        };
        return table;
    },

    //
    //
    //
    buildReportHeader(options, currentPage, pageCount) {
        const table = {
            widths: ["*", "*", "*"],
            body: [
                [
                    { text: "", alignment: "left" },
                    { text: "", alignment: "center" },
                    { text: "", alignment: "right" }
                ]
            ]
        };

        return table;
    },

    //
    //
    //
    buildReportFooter(options, currentPage, pageCount) {
        const reportDate = new Date().toDateString();

        const table = {
            widths: [250, "*", 250],
            body: [
                [{
                        table: this.buildBudtenderLogoTable(),
                        alignment: "left",
                        layout: "noBorders"
                    },
                    {
                        text: `Page ${currentPage.toString()} of ${pageCount} `,
                        alignment: "center"
                    },
                    {
                        text: `Report Date: ${reportDate} `,
                        alignment: "right"
                    }
                ]
            ]
        };

        return table;
    },

    //
    //
    //
    buildBudtenderLogoTable() {
        const table = {
            width: ["*", "*"],
            body: [
                [{
                        image: "budtenderLogoBig",
                        width: 15,
                        alignment: "right",
                        style: "footerCompanyLogo"
                    },
                    { text: "Budtender", alignment: "left", style: "footerCompanyName" }
                ]
            ]
        };
        return table;
    }
};

export default pdfReportFormatter;